export interface Reference<T> {
    value: T;
}